import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    seletor: {
      ordemAtiva: null,
      faturaAtiva: null,
    },
  },
  mutations: {
    setOrdemAtivaSeletor(state, ordem) {
      state.seletor.ordemAtiva = ordem;
    },
    setFaturaAtivaSeletor(state, ordem) {
      state.seletor.faturaAtiva = ordem;
    },
  },
  actions: {
    async gerar(context, idCR) {
      try {
        const response = await securedAxios.get(
          `/contareceber/${idCR}/gerar-boleto`,
          {
            responseType: "blob",
          }
        );
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    visualizar({ dispatch }, idCR) {
      return new Promise((resolve, reject) => {
        securedAxios
          .get(`/imprimir-boleto/${idCR}`, {
            responseType: "blob",
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            if (err.response && err.response.status === 404) {
              return dispatch("gerar", idCR).then(() => {
                dispatch("visualizar", idCR)
                  .then((pdf) => resolve(pdf))
                  .reject((err) => reject(err));
              });
            }
            return reject(err);
          });
      });
    },
    async arquivoBoleto(context, idCR) {
      try {
        const response = await securedAxios.get(`contareceber/${idCR}/arquivo`, {
          responseType: "blob",
        });
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
